function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import ReactConfigContext from "../../ReactConfigContext";
export default function ProfileModalImage(param) {
    var image = param.image, className = param.className;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    var _image_sizes;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid grid-cols-1 grid-rows-1", className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-[84%] ml-[6%] mt-[3%] md:mt-[6%] md:ml-[1%]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-w-1 aspect-h-1"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        sizes: (_image_sizes = image.sizes) !== null && _image_sizes !== void 0 ? _image_sizes : "400px",
        className: "rounded-full w-full h-full"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        width: "191",
        height: "176",
        viewBox: "0 0 191 176",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-full h-auto col-start-1 row-start-1 z-10 block md:hidden"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M190.996 131.593C191.045 107.061 173.221 87.0544 151.268 87C151.178 87 151.089 87.0045 151 87.0091L151 110.553C151.073 110.553 151.146 110.549 151.223 110.549C161.563 110.576 169.95 119.993 169.926 131.548C169.906 143.102 161.482 152.478 151.142 152.456C151.097 152.456 151.049 152.456 151.004 152.456L151.004 176C151.036 176 151.065 176 151.097 176C173.051 176.054 190.951 156.134 191 131.597",
        fill: "#FF5055"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M30.0036 60C13.4564 60 0 46.5508 0 30.0109C0 13.4709 13.4564 0 30.0036 0C46.5509 0 60 13.4636 60 30.0109C60 46.5581 46.5436 60 30.0036 60Z",
        fill: "#004E9C"
    })), /*#__PURE__*/ React.createElement("svg", {
        width: "324",
        height: "421",
        viewBox: "0 0 324 421",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-full h-auto col-start-1 row-start-1 hidden md:block"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M105 421H175.403C221.009 393.852 252 341.197 252 280.843C252 214.117 214.121 156.833 160.491 133H105L105 205.666C143.166 205.666 174.216 239.372 174.216 280.824C174.216 322.277 143.166 356.019 105 356.037L105 421Z",
        fill: "#FF5055"
    })), /*#__PURE__*/ React.createElement("svg", {
        width: "324",
        height: "421",
        viewBox: "0 0 324 421",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-full h-auto col-start-1 row-start-1 z-10 hidden md:block"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0.00486678 52.5779C-0.0535061 81.6236 21.3344 105.312 47.679 105.376C47.786 105.376 47.893 105.371 48 105.365L48 77.4887C47.9124 77.4887 47.8249 77.4941 47.7325 77.4941C35.3239 77.4619 25.2598 66.3124 25.289 52.6316C25.3133 38.9507 35.4212 27.8495 47.8298 27.8763C47.8833 27.8763 47.9416 27.8763 47.9951 27.8763L47.9951 -0.000232095C47.9562 -0.000232098 47.9222 -0.000232102 47.8833 -0.000232105C21.5387 -0.0645897 0.0583707 23.5216 -2.17833e-06 52.5726",
        fill: "#FFA500"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M324 42.2444V154.833C319.517 155.947 314.83 156.538 310.007 156.538C278.016 156.538 252 130.536 252 98.5591C252 66.5817 278.016 40.5381 310.007 40.5381C314.83 40.5381 319.518 41.1298 324 42.2444Z",
        fill: "#004E9C"
    })));
}

//# sourceMappingURL=ProfileModalImage.js.map